import { defineStore } from 'pinia';
import { ref } from 'vue';
import { FormEERData } from '../models/form-eer-data';

export const useFormEERDataStore = defineStore('FormEERDataStore', () => {
  const formEERData = ref({} as FormEERData);

  function setFormEERData(i: FormEERData) {
    formEERData.value = i;
  }

  function clearFormEERData() {
    formEERData.value = {} as FormEERData;
  }

  return {
    formEERData,
    setFormEERData,
    clearFormEERData,
  };
});
